import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Subject } from "rxjs";
import { GrupoService } from "../../../../../services/grupo.service";
import { SolicitudService } from "../../../../../services/solicitud.service";
import { DataTableDirective } from "angular-datatables";
import { Solicitud } from "../../../../../models/solicitud";

@Component({
  selector: "app-altas",
  templateUrl: "./altas.component.html",
  styleUrls: ["./altas.component.css"],
  providers: [GrupoService, SolicitudService]
})
export class AltasComponent implements OnInit {
  public identity;
  public token;
  public status;
  public status_update;
  public message_success_upds;
  public message_success;
  public message_error;
  public solicitudes;
  public solicitud;
  public file;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  public nombre;
  public apellidos;
  public telefono;
  public email;
  public licencia_funcionamiento;
  public nombre_establecimiento;
  public img;
  public estatus;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _solicitudService: SolicitudService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10
    };
    this.getSolicitudes();
    $(".loading").hide();
  }

  getSolicitudes() {
    this._solicitudService.getSolicitudes(this.token).subscribe(
      response => {
        // Obtener el token
        if (response.status == "success") {
          this.solicitudes = response.solicitudes;
          this.dtTrigger.next();
        }
      },
      error => {
        if (error["status"] == 401) {
          this._router.navigate(["logout/1"]);
        } else {
          this.message_error = error;
        }
      }
    );
  }

  getImage(solicitud_id) {
    this._solicitudService.getImage(this.token, solicitud_id).subscribe(
      response => {
        // Obtener el token
        this.file = URL.createObjectURL(response);
        location.href = this.file;
      },
      error => {
        if (error["status"] == 401) {
          this._router.navigate(["logout/1"]);
        }
      }
    );
  }

  createGrupo(solicitud_id) {
    var confirmCreate = confirm("¿Seguro que desea aceptar esta solicitud?")
    if (confirmCreate == true) {
      this.nombre = $("#nomAct" + solicitud_id).val();
      this.apellidos = $("#apAct" + solicitud_id).val();
      this.telefono = $("#telAct" + solicitud_id).val();
      this.email = $("#emailAct" + solicitud_id).val();
      this.telefono = $("#telAct" + solicitud_id).val();
      this.licencia_funcionamiento = $("#licAct" + solicitud_id).val();
      this.nombre_establecimiento = $("#estAct" + solicitud_id).val();

      this.solicitud = new Solicitud(
        solicitud_id,
        0,
        this.nombre,
        this.apellidos,
        this.email,
        '',
        this.telefono,
        this.licencia_funcionamiento,
        this.nombre_establecimiento,
        "",
        ""
      );

      $(".loading").show();

      this._solicitudService.createGrupo(this.token, this.solicitud).subscribe(
        response => {
          // Obtener el token
          if (response.status == "success") {
            alert(response.message);
            window.location.href = "./panel_de_control/altas";
          } else {
            $(".loading").hide();
            $(".alta").show();

            this.status = response.status;
            this.message_error = response.message;

            setTimeout(function () {
              $(".alta")
                .fadeTo(500, 1)
                .slideUp(500, function () {
                  $(".alta").hide();
                });
            }, 3000);
          }
        },
        error => {
          if (error["status"] == 401) {
            this._router.navigate(["logout/1"]);
          } else {
            this.message_error = error;
          }
        }
      );
    } else {
      return false
    }
  }

  deleteSolicitud(solicitud_id) {
    var confirmDelete = confirm("¿Seguro que desea cancelar esta solicitud?")
    if (confirmDelete == true) {

      let observacion = $("#observacion" + solicitud_id).val();
      let info = { observacion }
      $(".loading").show();
      this._solicitudService.delete(this.token, info, solicitud_id).subscribe(
        response => {
          $(".loading").hide();
          if (response.status == "success") {
            alert(response.message);
            location.href = "./panel_de_control/altas";
          }
        },
        error => {
          if (error["status"] == 401) {
            this._router.navigate(["logout/1"]);
          } else if (error.error.message) {
            $(".loading").hide();
            $(".alta").show();
            this.status = 'error';
            this.message_error = error.error.message;

            setTimeout(function () {
              $(".alta")
                .fadeTo(500, 1)
                .slideUp(500, function () {
                  $(".alta").hide();
                });
            }, 3000);
          } else {
            alert(' Existen problemas en el servidor, intente más tarde')
          }
        }
      );
    } else {
      return false
    }
  }
}
